export default {
    state: {
        locale: null, // An locale item { "locale": "en", "countryCode": "gb"}
    },
    getters: {
        /* findJobsPage: state => payload => state.findJobsPage,
        totalPostingCount: state => payload => state.totalPostingCount */
        getLocaleItem: state => payload => state.locale,
    },
    mutations: {
        setLocaleItem(state, localeItem) {
            state.locale = localeItem;
        },
    },
};
